import React, { useEffect, useState } from 'react'
import filterXss from 'xss'

import OnlineOrdersBenefits from 'Comps/ForRestaurants/OnlineOrdersBenefits'
import OnlineOrdersProcess from 'Comps/ForRestaurants/OnlineOrdersProcess'
import PartnerLogos from 'Comps/ForRestaurants/PartnerLogos'
import ChooseYourNeed from 'Comps/ForRestaurants/ChooseYourNeed'
import { createDerivedStateFromErrorLogger } from 'Utils/log'
import CallMeForm from 'Comps/ForRestaurants/CallMeForm'
import SavingsCalculator from 'Comps/SavingsCalculators/SavingsCalculator'
import WebsitePortfolio from 'Comps/ForRestaurants/WebsitePortfolio'
import { getSafeUrlParam } from 'Utils/url-params'
import { OFFER_TYPES } from 'App/config'
import RestaurateurFaq from 'Comps/ForRestaurants/RestaurateurFaq'

const url = filterXss(window.location.pathname)
const isRoot = url === '/dla-restauracji/zamowienia'

const offerTypeByURL = {
  '/dla-restauracji/zacznij-sprzedawac-online': OFFER_TYPES.NOT_SELLING,
  '/dla-restauracji/obniz-prowizje-portali': OFFER_TYPES.WANT_TO_REDUCE_COST,
}

const titlesByOfferType = {
  [OFFER_TYPES.NOT_SELLING]: 'Zacznij zarabiać, sprzedając online',
  [OFFER_TYPES.WANT_TO_REDUCE_COST]: 'Obniż prowizję portali z OtoStolik',
}

const subtitlesByOfferType = {
  [OFFER_TYPES.NOT_SELLING]:
    'Uruchom zamówienia onlinej na stronie www restauracji i zwiększ swoje zyski',
  [OFFER_TYPES.WANT_TO_REDUCE_COST]:
    'Zacznij sprzedawać online na własnej stronie dla Twojej restauracji i pozostaw zyski w swojej kieszeni',
}

const OnlineOrdersOffer = () => {
  const [restaurantName, setRestaurantName] = useState(null)
  useEffect(() => {
    document.querySelector('.until-react-spinner').remove()
    const restaurantName = getSafeUrlParam('rn')
    restaurantName && setRestaurantName(restaurantName.split('-').join(' '))
  }, [])

  if (isRoot) {
    return (
      <section className="for-restaurants-intro">
        <h1 className="fr-title">Zarabiaj więcej, sprzedając z OtoStolik</h1>
        <ChooseYourNeed className="mt-4 pt-4" />
      </section>
    )
  }

  const offerType = offerTypeByURL[url]
  return (
    <>
      <section className="for-restaurants-intro">
        <h1 className="fr-title">{titlesByOfferType[offerType]}</h1>
        {restaurantName && (
          <div className="mb-3">
            Oferta OtoStolik dla restauracji{' '}
            <span className="capitalize">{restaurantName}</span>
          </div>
        )}
        <h2 className="fr-subtitle">{subtitlesByOfferType[offerType]}</h2>
        <a
          href="#fill-form"
          className="js-scroll-trigger for-restaurants-cta-btn"
        >
          Zacznij teraz
        </a>
      </section>
      <section className="for-restaurants-why">
        <h2 className="fr-title">Dlaczego OtoStolik?</h2>
        <OnlineOrdersBenefits type={offerType} />
        {offerType === OFFER_TYPES.WANT_TO_REDUCE_COST && (
          <>
            <h2 className="fr-title">Ile możesz zaoszczędzić?</h2>
            <SavingsCalculator />
          </>
        )}
      </section>
      <section className="cta-try-now" id="fill-form">
        <div className="cta-section__content">
          <h2 className="fr-title">
            Zacznij już teraz - nie ponosisz żadnego ryzyka!
          </h2>
          <a
            href="https://admin.otostolik.pl/signup"
            target="_blank"
            rel="noopener noreferrer"
            className="for-restaurants-cta-btn cta-btn--secondary"
          >
            Wypełnij formularz zgłoszeniowy
          </a>
        </div>
      </section>
      <section className="for-restaurants-how">
        <h2 className="fr-title">Jak rozpocząć współpracę?</h2>
        <OnlineOrdersProcess />
        <a
          href="#fill-form"
          className="js-scroll-trigger for-restaurants-cta-btn"
        >
          Rozpocznij współpracę
        </a>
      </section>
      <CallMeForm
        id="call-me"
        title="Masz pytania i chcesz porozmawiać z żywą osobą?"
        text="Podaj numer telefonu - oddzwonimy w ciągu godziny!"
      />
      <section className="partners">
        <WebsitePortfolio />
      </section>
      <section className="cta-your-time">
        <div className="cta-section__content">
          <h2 className="fr-title">
            Teraz Twoja kolej na przyjmowanie zamówień on-line
          </h2>
          <a
            href="#fill-form"
            className="js-scroll-trigger for-restaurants-cta-btn"
          >
            Wypróbuj teraz
          </a>
        </div>
      </section>
      <section className="for-restaurants-how text-left pt-2">
        <h4 className="home-title home-title--smaller">Wciąż masz pytania?</h4>
        <RestaurateurFaq />
      </section>
      <CallMeForm
        id="call-me"
        title="Czy możemy Ci w czymś jeszcze pomóc?"
        text="Podaj numer telefonu - oddzwonimy w ciągu godziny!"
      />
    </>
  )
}

OnlineOrdersOffer.getDerivedStateFromError = createDerivedStateFromErrorLogger(
  'OnlineOrdersOffer'
)

export default OnlineOrdersOffer
